import { encodeStateParam } from "./encoding";

(function(d) {
  var a = d.createElement('script'); a.type = 'text/javascript';
  a.async = true; a.id = 'amazon-login-sdk';
  a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
  const amazonRoot = d.getElementById('amazon-root');
  if(amazonRoot) {
    amazonRoot.appendChild(a);
  }
})(document);

export const authWithAmazon = (clientId, state) => {
  const options = {
    interactive: 'auto',
    popup: false,
    response_type: 'code',
    scope: 'profile postal_code',
  };

  if(state) options.state = encodeStateParam(state);

  window.amazon.Login.setClientId(clientId);
  window.amazon.Login.authorize(options, window.location.origin);
};
